import { useState, useContext, useEffect } from "react";
import { useFormik, Form, FormikProvider } from "formik";
import * as Yup from "yup";
import {
  Grid,
  Button,
  Dialog,
  TextField,
  Typography,
  DialogContent,
} from "@mui/material";
//Import from project
import "../../Style/dialogstyle.scss";
import { useMutation } from "@apollo/client";
import { AuthContext } from "../../Context/AuthContext";
import { DialogTitleComp } from "../../Utils/Component"; 
import { CREATE_MAJOR, UPDATE_MAJOR } from "../../Schema/Major";

export default function MajorForm({
  open,
  editData,
  setRefetch,
  dialogTitle,
  handleClose,
  hideBackdrop,
}) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  // ================================= End upload Image ===============================

  const [createMajors] = useMutation(CREATE_MAJOR, {
    onCompleted: ({ createMajors }) => {
      setLoading(false);
      if (createMajors?.isSuccess === true) {
        setAlert(true, "success", createMajors?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", createMajors?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  const [updateMajors] = useMutation(UPDATE_MAJOR, {
    onCompleted: ({ updateMajors }) => {
      setLoading(false);
      if (updateMajors?.isSuccess === true) {
        setAlert(true, "success", updateMajors?.message);
        handleClose();
        resetForm();
        setRefetch();
      } else {
        setAlert(true, "error", updateMajors?.message);
      }
    },
    onError: ({ message }) => {
      setLoading(false);
      setAlert(true, "error", { messageKh: message, messageEn: message });
    },
  });

  //fromik
  const CheckValidation = Yup.object().shape({
    majorsNameEng: Yup.string().required(t("required")),
    majorsNameKh: Yup.string().required(t("required")),
  });

  const formik = useFormik({
    initialValues: {
      majorsNameEng: "",
      majorsNameKh: ""
    },

    validationSchema: CheckValidation,
    onSubmit: async (values) => {
      setLoading(true);
      if (dialogTitle === "Create") {
        createMajors({
          variables: {
            input: {
              ...values,
            },
          },
        });
      } else {
        updateMajors({
          variables: {
            id: editData?._id,
            input: {
              ...values,
            },
          },
        });
      }
    },
  });

  const {
    errors,
    touched,
    handleSubmit,
    setFieldValue,
    getFieldProps,
    resetForm,
  } = formik;

  useEffect(() => {
    if (editData) {
      setFieldValue("majorsNameKh", editData?.majorsNameKh);
      setFieldValue("majorsNameEng", editData?.majorsNameEng);
    }
  }, [editData, open]);

  return (
    <Dialog
      fullWidth
      open={open}
      maxWidth="xs"
      className="dialog-container"
      hideBackdrop={hideBackdrop}
    >
      <DialogTitleComp
        title={
          dialogTitle === "Create"
            ? t("modal_title_create_major")
            : t("modal_title_update_major")
        }
        classTitle={"dialog-title"}
        classIcon={"close-icon"}
        handleClose={handleClose}
      />

      <DialogContent dividers>
        <FormikProvider value={formik}>
          <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <Grid container rowSpacing={2} columnSpacing={3}>


              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_major_name")}(KH)
                </Typography>
                <TextField
                  className="text-field"
                  size="small"
                  fullWidth
                  placeholder={t("thead_major_name")}
                  {...getFieldProps("majorsNameKh")}
                  error={Boolean(touched.majorsNameKh && errors.majorsNameKh)}
                  helperText={touched.majorsNameKh && errors.majorsNameKh}
                />
              </Grid>



              <Grid item xs={12}>
                <Typography className={t("class-name-field-title")}>
                  {t("thead_major_name")}(ENG)
                </Typography>
                <TextField
                  className="text-field"
                  size="small"
                  fullWidth
                  placeholder={t("thead_major_name")}
                  {...getFieldProps("majorsNameEng")}
                  error={Boolean(touched.majorsNameEng && errors.majorsNameEng)}
                  helperText={touched.majorsNameEng && errors.majorsNameEng}
                />
              </Grid>


              <Grid item xs={12}>
                {loading ? (
                  <Button className={t("class-btn-create")} fullWidth>
                    {t("loading")}
                  </Button>
                ) : (
                  <Button
                    className={t("class-btn-create")}
                    fullWidth
                    onClick={handleSubmit}
                  >
                    {dialogTitle === "Create" ? t("create") : t("update")}
                  </Button>
                )}
              </Grid>
            </Grid>
          </Form>
        </FormikProvider>
      </DialogContent>
    </Dialog>
  );
}
